import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { AlertType } from '@tripointe/tripointe-cms/types';

const ICONS_BY_TYPE: Record<AlertType, string> = {
  warning: 'warning',
  info: 'info'
};

@Component({
  selector: 'tp-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  @Input() type: AlertType = null;

  get iconName(): string {
    return ICONS_BY_TYPE[this.type];
  }
}
